<template>
  <base-modal modal-content-class="bonus_modal midnight modal_glow">
    <div class="content">
      <base-image :src="modalImageSrc" image-class="bonus_img"></base-image>

      <h1>{{ getTranslations.home_points_multiplier_header }}</h1>

      <div class="bonus_time">
        <h2>{{ pointsText }}</h2>

        <p>{{ durationText }}</p>

        <div class="timer_box">
          <base-countdown-timer
            :initial-timer-in-seconds="bonusPhaseCountdownTimer"
            timer-format="hh:mm:ss"
            class-name="bonus_timer"
            @time:expired="handleTimeExpired"
          ></base-countdown-timer>
        </div>
      </div>

      <div class="text">
        <p>{{ descriptionBetweenText }}</p>

        <p>{{ getTranslations.home_points_multiplier_play_now }}</p>
      </div>

      <h3>{{ getTranslations.home_points_multiplier_start_new_game }}</h3>

      <base-button container-class="start_new" @button:click="$emit('game:start')">
        {{ getTranslations.home_points_multiplier_new_game_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import Vue from 'vue'
import BaseModal from '../../../common/modal/BaseModal'
import BaseButton from '../../../common/button/BaseButton'
import BaseImage from '../../../common/image/BaseImage'
import BaseCountdownTimer from '../../../common/timer/BaseCountdownTimer'

const moment = require('moment')

Vue.use(require('vue-moment'), {moment})

export default {
  name: 'bonus-multiplier',
  emits: ['game:start'],
  components: {
    BaseModal,
    BaseButton,
    BaseImage,
    BaseCountdownTimer
  },
  props: {
    startDate: {
      type: [String, Number, Date],
      default: ''
    },
    endDate: {
      type: [String, Number, Date],
      default: ''
    },
    multiplier: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      formattedStartDate: null,
      formattedEndDate: null,
      bonusPhaseCountdownTimer: null,
      bonusPhaseTotalDuration: null,
      isBonusPhaseRunning: false
    }
  },
  created () {
    this.initializeData()
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    modalImageSrc () {
      return `/static/images/x${this.multiplier}.svg`
    },
    pointsText () {
      return this.getTranslations[`home_points_multiplier_points_x${this.multiplier}`] || ''
    },
    durationText () {
      return `${this.getTranslations.home_points_multiplier_duration_pt_1 || ''} ${this.bonusPhaseTotalDuration} ${this.getTranslations[this.bonusPhaseTotalDuration === 1 ? 'home_points_multiplier_duration_pt_2' : 'home_points_multiplier_duration_pt_2_plural'] || ''}`
    },
    descriptionBetweenText () {
      const descriptionBetweenSecondPart = this.getTranslations[`home_points_multiplier_between_pt2_x${this.multiplier}`] || ''

      return (this.getTranslations.home_points_multiplier_between_pt1 && descriptionBetweenSecondPart)
        ? `${this.getTranslations.home_points_multiplier_between_pt1 || ''} ${this.formattedStartDate}–${this.formattedEndDate} ${descriptionBetweenSecondPart}`
        : ''
    }
  },
  methods: {
    initializeData () {
      moment.locale(localStorage.getItem('locale'))

      const currentDate = moment()
      const startDate = moment(this.startDate)
      const endDate = moment(this.endDate)

      this.formattedStartDate = startDate.format('HH:mm:ss')
      this.formattedEndDate = endDate.format('HH:mm:ss')
      this.bonusPhaseTotalDuration = Math.ceil(moment.duration(endDate.diff(startDate)).asHours())
      this.isBonusPhaseRunning = currentDate.isBefore(endDate)

      this.bonusPhaseCountdownTimer = this.isBonusPhaseRunning
        ? Math.ceil(moment.duration(endDate.diff(currentDate)).asSeconds())
        : 0
    },
    handleTimeExpired () {
      this.isBonusPhaseRunning = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/PointsMultiplier.vue